export default __webpack_public_path__ + "static/media/mobilechipsback.3a1471f2.png";